import React from 'react';
import { Link } from 'react-router-dom';

const SubscriptionCancel = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        {/* Cancel Icon */}
        <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>

        {/* Cancel Message */}
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Subscription Cancelled</h2>
        <p className="text-gray-600 mb-6">
          Your subscription payment was cancelled. No charges were made to your account.
        </p>

        {/* Information Box */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
          <h3 className="font-semibold text-blue-800 mb-2">Why subscribe?</h3>
          <ul className="space-y-1 text-sm text-blue-700">
            <li>• Access to all trade categories</li>
            <li>• Unlimited service listings</li>
            <li>• Secure payment processing</li>
            <li>• Customer review system</li>
            <li>• Professional marketplace exposure</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Link
            to="/subscription"
            className="block w-full bg-gradient-to-r from-blue-500 to-purple-500 text-white py-3 px-6 rounded-lg font-semibold"
          >
            Try Again
          </Link>
          <Link
            to="/dashboard"
            className="block w-full bg-gray-200 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Browse Marketplace
          </Link>
          <Link
            to="/provider-dashboard"
            className="block w-full text-gray-600  transition-colors"
          >
            Back to Dashboard
          </Link>
        </div>

        {/* Help Text */}
        <p className="text-sm text-gray-500 mt-6">
          Need help? Contact our support team at <a href="mailto:Corporate.dccorp@gmail.com" className="text-blue-600  underline">Corporate.dccorp@gmail.com</a> for assistance with your subscription.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCancel;